(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/params.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/params.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.react.hooks,
  useHomeLocation = _svs$lyckoplatsen$com.useHomeLocation,
  useHomeLocationSelfService = _svs$lyckoplatsen$com.useHomeLocationSelfService,
  useGeolocation = _svs$lyckoplatsen$com.useGeolocation;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_play.jotai.atoms,
  shouldAutoPayAtom = _svs$lyckoplatsen$com2.shouldAutoPayAtom,
  shouldPayAfterDepositAtom = _svs$lyckoplatsen$com2.shouldPayAfterDepositAtom,
  isGameValidAtom = _svs$lyckoplatsen$com2.isGameValidAtom,
  randomLocationTriggerAtom = _svs$lyckoplatsen$com2.randomLocationTriggerAtom;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const PAGE_INTRO_ANIMATION_MS = 1600;
const Params = () => {
  const ParamHandler = svs.lyckoplatsen.react.ParamHandler;
  const setShouldAutoPay = useSetAtom(shouldAutoPayAtom);
  const setShouldPayAfterDeposit = useSetAtom(shouldPayAfterDepositAtom);
  const setRandomLocationTrigger = useSetAtom(randomLocationTriggerAtom);
  const isGameValid = useAtomValue(isGameValidAtom);
  const handleHomeLocation = useHomeLocation();
  const handleHomeLocationSelfService = useHomeLocationSelfService();
  const handleGeoLocation = useGeolocation();
  const params = [{
    key: 'locationHome',
    action: isSelfService ? handleHomeLocationSelfService : handleHomeLocation
  }, {
    key: 'pay',
    action: () => {
      setShouldAutoPay(true);
    }
  }, {
    key: 'locationType',
    action: type => {
      var _home$current$random$, _home$current$random;
      return (_home$current$random$ = (_home$current$random = {
        home: isSelfService ? handleHomeLocationSelfService : handleHomeLocation,
        current: handleGeoLocation,
        random: () => setTimeout(() => {
          setRandomLocationTrigger(count => count + 1);
        }, PAGE_INTRO_ANIMATION_MS)
      })[type]) === null || _home$current$random$ === void 0 ? void 0 : _home$current$random$.call(_home$current$random);
    }
  }, {
    key: 'afterpay',
    action: () => {
      setShouldPayAfterDeposit(isGameValid);
    }
  }];
  return React.createElement(ParamHandler, {
    params: params
  });
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Params
});

 })(window);